import { AsyncPipe } from '@angular/common';
import {
  Component,
  EnvironmentInjector,
  inject,
  runInInjectionContext,
  signal,
  viewChild
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, RouterLink } from '@angular/router';
import { BackButtonComponent } from '@app/components/back-button/back-button.component';
import { HeaderComponent } from '@app/components/base/header.component';
import { IconComponent } from '@app/components/icon/icon.component';
import { ImageComponent } from '@app/components/image/image.component';
import { filter } from 'rxjs';

import { HamburgerComponent } from '../hamburger/hamburger.component';

@Component({
  selector: 'app-mobile-header',
  imports: [AsyncPipe, BackButtonComponent, HamburgerComponent, IconComponent, RouterLink, ImageComponent],
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss']
})
export class MobileHeaderComponent extends HeaderComponent {
  private readonly injector: EnvironmentInjector = inject(EnvironmentInjector);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  public hamburgerMenu = viewChild<HamburgerComponent | undefined>(HamburgerComponent);
  public showMenuButton = signal(true);
  public showBackButton = signal(false);

  constructor() {
    super();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        let currentRoute = this.route.root;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }
        runInInjectionContext(this.injector, () => {
          currentRoute.data.pipe(takeUntilDestroyed()).subscribe(data => {
            this.showBackButton.set(data['showBackButton'] || false);
            this.showMenuButton.set(!this.showBackButton());
            this.changeDetectorRef.detectChanges();
          });
        });
      });
  }

  public openHamburgerMenu(): void {
    if (this.hamburgerMenu()) {
      this.hamburgerMenu()?.openDialog();
    }
  }

  public closeHamburgerMenu(): void {
    this.hamburgerMenu()?.closeDialog();
  }
}
